import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";
import ColorInput from "../../formElements/ColorInput";

function BTKResultForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Vysledok'} label={'Výsledok'} value={data.Vysledok} onChange={update}/>
            <div className="col-sm-offset-2 col-sm-1">
                <ColorInput name={'Farba'} label={'Farba'} value={data.Farba} onChange={update}/>
            </div>
        </>
    )

    return (
        <GenericForm label="Výsledok kontroly BTK"
                     labelNew="Pridať výsledok kontroly BTK"
                     baseUrl='/btk/btks_results/'
                     formContent={formContent}/>
    )

}

export default BTKResultForm
